import { JobStage } from '../../entities/JobStage';
import { ApiService } from '../ApiService';

export class JobStageService {
  public static list(jobId: string): Promise<JobStage[]> {
    return ApiService.get<JobStage[]>(`/api/jobs/${jobId}/job_stages`);
  }
}
